import {
  ContextEdge,
  ContextNode,
  RawContextNode,
} from '@/types/context/context-page';

export const transformNodes = (nodes: RawContextNode[]): ContextNode[] => {
  const transformedNodes: ContextNode[] = [];
  console.log('Nodes = ', nodes);
  (nodes ?? []).forEach((node) => {
    transformedNodes.push({
      ...node,
      id: node._id,
    });
  });
  return transformedNodes;
};

export const createEdgesFromNodes = (nodes: ContextNode[]): ContextEdge[] => {
  const edges: ContextEdge[] = [];
  nodes.forEach((node) => {
    node.children_context_nodes.forEach((childId) => {
      edges.push({ source: node.id, target: childId });
    });
  });
  return edges;
};

// Deep comparison function
export const areNodesEqual = (
  prevNodes: ContextNode[],
  newNodes: ContextNode[]
): boolean => {
  if (prevNodes.length !== newNodes.length) return false;

  // Create maps for faster lookup
  const prevMap = new Map(prevNodes.map((node) => [node.id, node]));
  const newMap = new Map(newNodes.map((node) => [node.id, node]));

  // Check if all nodes exist and have the same properties
  for (const [id, prevNode] of prevMap) {
    const newNode = newMap.get(id);
    if (!newNode) return false;

    // Compare basic properties
    if (prevNode.content !== newNode.content) return false;
    if (prevNode.context_type !== newNode.context_type) return false;

    // Compare children arrays
    if (
      prevNode.children_context_nodes.length !==
      newNode.children_context_nodes.length
    )
      return false;

    // Check if all children exist in both arrays
    const prevChildren = new Set(prevNode.children_context_nodes);
    for (const childId of newNode.children_context_nodes) {
      if (!prevChildren.has(childId)) return false;
    }
  }

  return true;
};
